import {useCallback, useMemo} from "react";
import {TileSpread} from "../../../../components/Tile.tsx";
import {InspectorWasteTile} from "../../../../inspector/InspectorWasteTile.tsx";
import {PageBody, PageHeader, PageShell} from "../../../../routing/shell.tsx";
import {Stack} from "@mui/joy";
import {TopBar} from "../../../../components/TopBar.tsx";
import {createFileRoute, useNavigate} from "@tanstack/react-router";
import {IconToggleSwitch, ToggleBar} from "../../../../components/ToggleBar.tsx";
import {tieredActiveIcons} from "../../../../fa.tsx";
import {sortOrderIcons} from "../../../../tq/tqutil.tsx";
import {TieredOrActive} from "../../../../dispatch/tieredOrActive.tsx";
import {SortOrder} from "../../../../rpc/webrpc-client.gen.ts";
import {InspectorFacet, inspectorFacetIcons, validateInspectionSettings} from "../../../../inspector/navi.tsx";
import {useBomb} from "../../../../bomb/bomb.tsx";
import {BundleCapsule} from "../../../../bundle/capsule.tsx";
import {cmpActorScenesNewestFirst} from "../../../../timeline/timeline.tsx";

import {useInspectorWastes} from "../../../../inspector/inspector.tsx";

// function cmpInspectorWasteTieredOrder(a: VenuedWaste, b: VenuedWaste) {
//     return cmpById(a.waste, b.waste);
// }

function InspectWasteSpread({venueId}: { venueId: string }) {
    const ixwsTqrv = useInspectorWastes({venueId});
    const sorted = useMemo(() => (ixwsTqrv.data ?? []).toSorted(cmpActorScenesNewestFirst),
        [ixwsTqrv.data]);

    return <TileSpread foods={sorted} Component={({food: ixw}) =>
        <InspectorWasteTile key={ixw.waste.id} wasteId={ixw.waste.id}>
            {ixw.lastBundle ? <BundleCapsule bundle={ixw.lastBundle}/> : null}
        </InspectorWasteTile>}
                       estimatedHeight={200}/>
}

function InspectWastePage() {
    const pathParams = Route.useParams();
    const search = Route.useSearch();
    const venueId = pathParams.id;
    const navigate = useNavigate();
    const bomb = useBomb();
    const ixwTqrv = useInspectorWastes({venueId});

    const setOrder = useCallback((next: TieredOrActive) => {
        navigate({to: Route.to, params: pathParams, search: {...search, order: next}}).catch(bomb);
    }, [bomb, navigate, pathParams, search]);

    const setFacet = useCallback((facet: InspectorFacet) => {
        navigate({to: `../${facet}`, params: pathParams, search}).catch(bomb);
    }, [bomb, navigate, pathParams, search]);

    const sortOrder = search.sortOrder;
    const setSortOrder = useCallback((next: SortOrder) => {
        navigate({to: Route.to, params: pathParams, search: {...search, sortOrder: next}}).catch(bomb);
    }, [bomb, navigate, pathParams, search]);

    return <PageShell>
        <PageHeader>
            <Stack direction="column">
                <TopBar/>
                <ToggleBar>
                    <IconToggleSwitch dispatchValue={setOrder} icons={tieredActiveIcons} value={search.order}
                                      disabled={!((ixwTqrv.data?.length ?? 0) > 1)}/>
                    <IconToggleSwitch dispatchValue={setFacet} icons={inspectorFacetIcons} value="waste"/>
                    <IconToggleSwitch dispatchValue={setSortOrder} icons={sortOrderIcons} value={sortOrder}
                                      disabled={!((ixwTqrv.data?.length ?? 0) > 1)}/>
                </ToggleBar>
            </Stack>
        </PageHeader>
        <PageBody>
            <InspectWasteSpread venueId={venueId}/>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/venue/$id/inspect/waste")({
    component: InspectWastePage,
    validateSearch: validateInspectionSettings,
});

